import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	getAccountPortfolio,
	getAccountAutoStash,
	getAccountCards,
	getAccountBankAccounts,
} from 'stash/actions/api/';
import {
	Text,
	Box,
	PrimaryButton,
	SmartLink,
	CheckmarkIllustration,
	Layout,
	Flex,
} from '@stashinvest/ui';
import { SignUpStep } from '../SignUpScreenLayout';
import BuyVerification from 'stash/components/buy/BuyVerification';

const mapStateToProps = (state, ownProps) => ({
	name: state.entities.user.first_name,
	accountId: state.entities.account_by_type.PERSONAL_BROKERAGE,
});

const mapDispatchToProps = (dispatch) => ({
	refreshAccount: (accountId) => {
		return Promise.all([
			dispatch(getAccountPortfolio(accountId)),
			dispatch(getAccountCards(accountId)),
			dispatch(getAccountAutoStash(accountId)),
			dispatch(getAccountBankAccounts(accountId)),
		]);
	},
});

const SignUpInvestCompleteAddOn = ({ name, accountId, refreshAccount }) => {
	useEffect(() => {
		refreshAccount(accountId);
	}, [refreshAccount, accountId]);

	return (
		<Layout.PageWrap mt="0">
			<BuyVerification />
			<SignUpStep>
				<Flex flexDirection={{ mobile: 'column' }} alignItems="center">
					<CheckmarkIllustration mx="auto" mb="l" />
					<Box>
						<Text.H1 size="3" mb="xxs">
							It’s official, {name}!
						</Text.H1>
						<Box maxWidth="28rem" width="100%" mb="s">
							<Text mb="m">You’ve opened your Invest account.</Text>
						</Box>
						<PrimaryButton
							as={SmartLink}
							to={`/portfolio?account_id=${accountId}`}
						>
							Take me to my account
						</PrimaryButton>
					</Box>
				</Flex>
			</SignUpStep>
		</Layout.PageWrap>
	);
};

SignUpInvestCompleteAddOn.propTypes = {
	name: propTypes.string,
	accountId: propTypes.string,
	refreshAccount: propTypes.func,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SignUpInvestCompleteAddOn);
